<ng-container *ngIf="!isCampaign; else campaignTemplate">
  <div class="container" [ngClass]="{'recommended': plan.preferred}">
    <div class="header">
      <p *ngIf="plan.preferred">Melhor Escolha</p>
    </div>
    <div class="body">
      <div class="price">
        <p *ngIf="isNotCustomPlan else customPlan">R$
          <b>{{plan.totalValue}}</b> /mês*
        </p>
        <ng-template #customPlan>
          <p>a partir de R$ <input maxlength="4" type="number" size="4" min="300" [value]="customPlanValue"
              (input)="updateCustomPlanValue($event.target.value)" (focusout)="checkCustomValue($event)" />/mes*</p>
          <p class="error-message-customValue" *ngIf="showCustomValueError">Você não pode adiquirir esse produto por
            menos
            de R$ {{plan.baseValue}} </p>
        </ng-template>
      </div>

      <div class="economyRater" *ngIf="plan.featuredText">
        <img src="assets/images/icons/gift_alt_green.svg" *ngIf="plan.preferred">
        <img src="assets/images/icons/gift.svg" *ngIf="!plan.preferred">
        <p>{{plan.featuredText}}</p>
      </div>
      <div>
        <p>O que você pode fazer</p>
      </div>
      <div class="features">
        <div class="feature-list" *ngIf="plan.featureList.length > 0">
          <ng-container *ngFor="let feature of plan.featureList; let last = last">
            <div class="feature">
              <div class="contentLeft">
                <p class="quantity">
                  {{feature.requests}}
                </p>
              </div>
              <div class="contentRight">
                <p class="featureName">
                  {{feature.name}}
                </p>
                <p class="featureValue" *ngIf="feature.fromValue || feature.toValue">
                  ( <span class="fromValue">
                    {{feature.fromValue }}
                  </span>
                  <span class="toValue">
                    {{feature.toValue }}
                  </span> )
                </p>
              </div>
            </div>
            <div class="line" *ngIf="!last">
              <p>ou</p>
              <hr>
            </div>
          </ng-container>
          <div class="line" *ngIf="plan.featureList.length > 0">
            <hr>
          </div>
        </div>

        <ng-container *ngIf="plan.additionalProducts && plan.additionalProducts.length > 0">
          <div class="additional-features" *ngFor="let additional of plan.additionalProducts">
            <div *ngIf="additional.icon" class="contentLeft">
              <img src={{additional.icon}} alt="" srcset="">

            </div>
            <div class="contentRight">
              <h1>{{additional.title}}</h1>
              <p [innerHTML]="additional.subtitle"></p>
            </div>
          </div>
        </ng-container>

        <div class="subscribe-button" *ngIf="!this.hiddenButton" [ngClass]="{'disable': this.isActivePlan}">
          <button (click)="onBuyClick()">{{buttonLabel}}</button>
        </div>

      </div>
    </div>
  </div>
</ng-container>
<ng-template #campaignTemplate>
  <div class="container campaign-layout" [ngClass]="{'recommended-campaign': plan.preferred}">

    <div class="header-campaign">
      Melhor escolha
    </div>

    <div class="body">
      <div class="price">
        <div class="price-container" *ngIf="isNotCustomPlan else customPlan">
          <div class="from" *ngIf="plan.appliedDiscounts?.length > 0">
            De R$ {{plan.baseValue.toFixed(2).replace('.', ',')}}
          </div>
          <p>
            R$ <b>{{plan.totalValue}}</b> /mês* <span class="payment-info"></span>
          </p>
        </div>
        <ng-template #customPlan>
          <p>a partir de R$ <input maxlength="4" type="number" size="4" min="300" [value]="customPlanValue"
              (input)="updateCustomPlanValue($event.target.value)" (focusout)="checkCustomValue($event)" />/mes*</p>
          <p class="error-message-customValue" *ngIf="showCustomValueError">Você não pode adiquirir esse produto por
            menos
            de R$ {{plan.baseValue}} </p>
        </ng-template>
      </div>

      <div class="economyRater" *ngIf="plan.featuredText">
        <img src="assets/images/icons/gift_alt_green.svg" class="gift-icon">
        <p>{{plan.featuredText}}</p>
      </div>

      <div class="features-label">O que você pode fazer:</div>

      <div class="features">
        <div class="feature-list" *ngFor="let feature of plan.featureList; let last = last">
          <div class="feature">
            <div class="contentLeft">
              <p class="quantity">{{feature.requests}}</p>
            </div>
            <div class="contentRight">
              <p class="featureName">{{feature.name}}</p>
              <p class="featureValue" *ngIf="feature.fromValue || feature.toValue">
                ( <span class="old-price">{{feature.fromValue}}</span>
                <span class="new-price-bold">{{feature.toValue}}</span> )
              </p>
            </div>
          </div>
          <div class="line" *ngIf="!last">
            <p>ou</p>
            <hr>
          </div>
        </div>

        <ng-container *ngIf="plan.additionalProducts?.length > 0">
          <div class="additional-features-campaign" *ngFor="let additional of plan.additionalProducts">
            <div class="bonus-content">
              <div class="title-container">
                <!-- <img [src]="additional.icon" class="gift-icon"> -->
                <h1 class="bonus-title">{{additional.title}}</h1>
              </div>
              <div class="text-container" *ngIf="!hideDetails">
                <p class="bonus-subtitle" [innerHTML]="additional.subtitle"></p>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="hideDetailsButton" *ngIf="plan.additionalProducts?.length > 0">
        <button (click)="hideDetailsClick()" [class.open]="!hideDetails">{{hideDetailsLabel}}
          <img src="/assets/images/icons-stepper/chevron_left.svg"></button>
      </div>

      <div class="subscribe-button-campaign" [ngClass]="{'disable': this.isActivePlan}">
        <button (click)="onBuyClick()">{{buttonLabel}}</button>
      </div>
    </div>
  </div>
</ng-template>